

/**
 * 分享。自动引入sdk
 */

define(function (require, exports, module) {

    var Base = require('c-base');
    var Url = require('c-url');

    var envi = require('c-nenv');

    var wechat = require('c-up-wechat');

    module.exports = Base.extend({

        defaults: {
            isRandomHost: 1
        },
        /**
         * 初始化入口
         * 1. 引入微信jssdk
         */
        initialize: function initialize() {},

        /**
         * 设置分享信息——外部可直接调用
         * @param data {object}
         *      - title 
         *      - link
         *      - imgUrl
         *      - desc
         *      - onMenuShareSuccess {function}
         *      - onMenuShareCancel {function}
         */
        set: function set(data) {
            var self = this;

            if (envi.platform.isWeixin) {

                if (wechat.ready) {
                    self._setShareData(data);
                } else {
                    wechat.on('ready', function () {
                        self._setShareData(data);
                    });
                }
            }

            if (data.title) {
                document.title = data.title;
            }
            data.imgUrl && this.insertShareIcon(data.imgUrl);
        },
        /**
         * 分享信息
         */
        _setShareData: function _setShareData(data) {
            var self = this;
            var title = data.title || document.title;
            var link = data.link || location.href;
            var imgUrl = data.imgUrl;
            var desc = data.desc;

            var onMenuShareSuccess = data.onMenuShareSuccess || function () {};
            var onMenuShareCancel = data.onMenuShareCancel || function () {};

            // 分享到朋友圈
            wx.onMenuShareTimeline({
                title: desc, // 分享标题
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                success: function success() {
                    // 用户确认分享后执行的回调函数
                    self.emit('onMenuShareSuccess', {
                        type: 'timeline'
                    });
                    onMenuShareSuccess({
                        type: 'timeline'
                    });
                },
                cancel: function cancel() {
                    // 用户确认分享后执行的回调函数
                    self.emit('onMenuShareCancel', {
                        type: 'timeline'
                    });
                    onMenuShareCancel({
                        type: 'timeline'
                    });
                }
            });

            // 发送微信好友
            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                desc: desc,
                type: 'link', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function success() {
                    self.emit('onMenuShareSuccess', {
                        type: 'appmessage'
                    });
                    onMenuShareSuccess({
                        type: 'appmessage'
                    });
                },
                cancel: function cancel() {
                    self.emit('onMenuShareCancel', {
                        type: 'appmessage'
                    });
                    onMenuShareCancel({
                        type: 'appmessage'
                    });
                }
            });

            // “分享到QQ”
            wx.onMenuShareQQ({
                title: title, // 分享标题
                link: link, // 分享链接
                imgUrl: imgUrl, // 分享图标
                desc: desc,
                success: function success() {
                    self.emit('onMenuShareSuccess', {
                        type: 'qq'
                    });
                    onMenuShareSuccess({
                        type: 'qq'
                    });
                },
                cancel: function cancel() {
                    self.emit('onMenuShareCancel', {
                        type: 'qq'
                    });
                    onMenuShareCancel({
                        type: 'qq'
                    });
                }
            });
        },

        /**
         * 在页面中插入游戏图标
         */
        insertShareIcon: function insertShareIcon(icon) {
            $(document.body).children().eq(0).before('<img src="' + icon + '" style="position:absolute;left:-0.03125rem;top:-0.03125rem;width:0.03125rem;height:0.03125rem;" />');
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-wechatshare/dist/index.js
// module id = 204
// module chunks = 0 1